var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("alert alert-custom alert-light-" + _vm.type + " fade show py-2 px-4")},[_c('div',{staticClass:"alert-icon pr-3"},[_c('i',{class:_vm.icon || _vm.alertIcon,staticStyle:{"font-size":"1.5rem"}})]),_vm._v(" "),_c('div',{staticClass:"alert-text"},[_c('span',{staticClass:"d-block font-size-sm"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86f2a180","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/component/alert.vue
// module id = null
// module chunks = 